import { render, staticRenderFns } from "./videoer.vue?vue&type=template&id=4a26f228&"
import script from "./videoer.vue?vue&type=script&lang=js&"
export * from "./videoer.vue?vue&type=script&lang=js&"
import style0 from "./videoer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports